import { EventTags } from "../../data";
export const mapEventIcons = (x) => {
    x.livestreamIcon = {
        active: checkAvailability(x.tags.indexOf(EventTags.LiveStreaming)),
        tooltip: "LiveStream"
    };
    x.fastmarketIcon = {
        active: checkAvailability(x.tags.indexOf(EventTags.FastMarket)),
        tooltip: "FastMarket"
    };
    x.pulsebetIcon = {
        active: checkAvailability(x.tags.indexOf("Pulse")),
        tooltip: "PulseBet"
    };
    return x;
};
const checkAvailability = (index) => index === -1 ? false : true;
//# sourceMappingURL=mapEventIcons.js.map